import { render, staticRenderFns } from "./BaseDialogToSelectNfe.vue?vue&type=template&id=195ac58d&scoped=true&"
import script from "./BaseDialogToSelectNfe.vue?vue&type=script&lang=js&"
export * from "./BaseDialogToSelectNfe.vue?vue&type=script&lang=js&"
import style0 from "./BaseDialogToSelectNfe.vue?vue&type=style&index=0&id=195ac58d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195ac58d",
  null
  
)

export default component.exports